import type { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { graphql } from 'gql';
import type { ConstructionTypeData } from 'gql/graphql';

import { useMemo } from 'react';

export const bimWorkOrderChangeConstructionTypesGql = graphql(`
    query bimWorkOrderChangeConstructionTypes($workOrderChangeId: Long!) {
        bimWorkOrderChangeConstructionTypes(workOrderChangeId: $workOrderChangeId) {
            data {
                name
                id
                catalogId
                fullName
            }
        }
    }
`);

export const useContractChangeConstructionTypes = (
    workOrderChangeId?: number,
    withEffect = true,
): [ConstructionTypeData[], RequestStatus, any] => {
    const requestVariables = useMemo(
        () => ({
            workOrderChangeId,
        }),
        [workOrderChangeId],
    );

    const [bimContractConstructionTypesData, bimContractConstructionTypesStatus, bimContractConstructionTypesError] =
        useRequest({
            requestId: 'bimWorkOrderChangeConstructionTypes',
            query: bimWorkOrderChangeConstructionTypesGql,
            withEffect,
            variables: requestVariables,
        });

    const data = useMemo(
        () =>
            (bimContractConstructionTypesData?.bimWorkOrderChangeConstructionTypes?.data?.filter((i) => !!i) ||
                []) as ConstructionTypeData[],
        [bimContractConstructionTypesData?.bimWorkOrderChangeConstructionTypes?.data],
    );

    return [data, bimContractConstructionTypesStatus, bimContractConstructionTypesError];
};
